// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__eMQeC","image":"Image_image__Jo8M7","rounded":"Image_rounded__tXnOd"};